import { Reveal } from "./Reveal";
import { PALMARES, HONORS } from "./data";
import { useContent } from "@/lib/useContent";
import { Trophy, Medal } from "lucide-react";

const TIER_COLORS = { oro: "#d4a017", plata: "#9e9e9e", bronce: "#cd7f32" };

export const Palmares = () => {
  const palmares = useContent("palmares", PALMARES);
  const honors = useContent("honors", HONORS);
  return (
    <section id="palmares" className="relative py-24 md:py-32 bg-[#eef1f7] grain-overlay">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal className="max-w-3xl">
          <span className="section-tag">Palmarés</span>
          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-navy">
            Una vitrina cargada de gloria
          </h2>
          <p className="mt-5 text-lg text-gray-600 leading-relaxed">
            Cada título es fruto del esfuerzo de jugadores, cuerpo técnico, dirigentes y toda una comunidad.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {palmares.map((p, i) => (
            <Reveal key={p.id || p.label} delay={i * 0.08}>
              <div className="bg-white rounded-2xl border border-gray-100 p-6 sm:p-8 text-center shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all">
                <Trophy className="h-8 w-8 mx-auto text-gold" />
                <div className="mt-3 text-5xl sm:text-6xl font-extrabold text-navy tracking-tighter" style={{ fontFamily: "Outfit" }}>
                  {p.count}
                </div>
                <div className="mt-2 text-sm font-semibold text-gray-500 uppercase tracking-wide">{p.label}</div>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-5">
          {honors.map((h, i) => (
            <Reveal key={h.id || h.title} delay={i * 0.05}>
              <div className="flex items-center gap-4 bg-white rounded-xl border border-gray-100 p-5 shadow-sm">
                <div
                  className="h-12 w-12 rounded-xl flex items-center justify-center shrink-0"
                  style={{ backgroundColor: `${TIER_COLORS[h.tier]}1a` }}
                >
                  <Medal className="h-6 w-6" style={{ color: TIER_COLORS[h.tier] }} />
                </div>
                <div>
                  <span className="text-xs font-bold uppercase tracking-wider" style={{ color: TIER_COLORS[h.tier] }}>
                    {h.year}
                  </span>
                  <h3 className="text-base font-semibold text-navy leading-snug">{h.title}</h3>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
